import { useTranslation } from "react-i18next";

const midCtaBg =
  "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20modern%20residential%20neighborhood%20with%20contemporary%20steel%20frame%20houses%2C%20green%20landscape%2C%20warm%20afternoon%20sunlight%2C%20premium%20architectural%20photography%2C%20warm%20cream%20and%20earth%20tones%2C%20editorial%20quality%20with%20soft%20natural%20background%2C%20bird%20eye%20view%20of%20luxury%20home%20community&width=1600&height=600&seq=12&orientation=landscape";

export default function MidCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img src={midCtaBg} alt="現代住宅社區鳥瞰" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-r from-graphite/85 via-graphite/75 to-graphite/85" />
      </div>

      <div className="relative z-10 section-padding">
        <div className="container-main text-center max-w-3xl mx-auto">
          <span className="tag-label mb-6 inline-block">{t("portfolio.mid.label")}</span>
          <h2 className="text-white mb-4">{t("portfolio.mid.title")}</h2>
          <p className="text-cream/85 mb-10 max-w-2xl mx-auto">{t("portfolio.mid.desc")}</p>
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary gap-2 inline-flex"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            {t("portfolio.mid.cta")}
          </a>
        </div>
      </div>
    </section>
  );
}